export enum UserAccountTypes {
	personal = "PERSONAL",
	business = "BUSINESS",
}

export enum UserDepartments {
	MarketingBrand = "Marketing & Brand",
	MediaCommunications = "Media & Communications",
	DesignCreative = "Design & Creative",
	BusinessDevelopment = "Business Development",
	Sales = "Sales",
	ProjectProgrammeManagement = "Project & Programme Management",
	CustomerService = "Customer Service",
	Operations = "Operations",
	ProductManagement = "Product Management",
	FinanceAccounting = "Finance & Accounting",
	Administration = "Administration",
	InformationTechnology = "Information Technology",
	LegalCompliance = "Legal & Compliance",
	HumanResources = "Human Resources",
	CommunitySocialServices = "Community Social Services",
	ExecutiveManagement = "Executive Management",
}

export enum UserNumberOfEmployees {
	OnlyMe = "Only me",
	TwoToTen = "2-10",
	ElevenToFifty = "11-50",
	FiftyOneToFiveHundred = "51-500",
	FiveHundredPlus = "501+",
}

export enum UserOrganizationType {
	SmallBusiness = "Small business",
	MediumSizedBusiness = "Medium-sized business",
	LargeCorporation = "Large corporation",
	Startup = "Startup",
	NonProfit = "Non-profit",
	Educational = "Educational",
	Agency = "Agency",
}

export enum UserAccountUse {
	Personal = "Personal",
	PrimaryJob = "Primary Job",
}
